import Extension from "../base/extension";

class SampleProductValidation extends Extension {
  constructor(name) {
    super(name);
  }

  init() {

    let title, quantity, key;

    document.addEventListener("cart:added", function(event) {
      title = event.detail.addResponse.title;
      quantity = event.detail.addResponse.quantity;
      key = event.detail.addResponse.key;
      this.validateCart(title, quantity, key, event);
      
    }.bind(this));

    document.addEventListener("cart:changed", function(event) {
      if (event.detail.changeResponse.items_added.length !== 0) {
        title = event.detail.changeResponse.items_added[0].title;
        quantity = event.detail.changeResponse.items_added[0].quantity;
        key = event.detail.changeResponse.items_added[0].view_key;
      } else {
        title = event.detail.changeResponse.items_removed[0].title;
        quantity = event.detail.changeResponse.items_removed[0].quantity;
        key = event.detail.changeResponse.items_removed[0].view_key;
      }
      this.validateCart(title, quantity, key, event);
    }.bind(this));

    document.addEventListener("minicart:rendered", () => {
      if (window.showSampleLimitWarning) {
        const message = document.querySelector(".sample-validation-message");
        if (message) {
          message.classList.remove("visually-hidden");
        }
        // Reset flag
        window.showSampleLimitWarning = false;
      }
    });
  }

  async validateCart(title, quantity, key, event) {

    const MAX_SAMPLE_QUANTITY = 6;

    let response = await fetch(`${routes.cart_url}.js`);
    response = await response.json();

    const hasSample = response.items.some(item =>
      item.title && /Samples?\s-/i.test(item.title)
    );
    
    if (hasSample) {
      console.log(this.logPrefix, "Found an item with 'Sample -' in the title");

      const currentSampleQuantity = response.items.reduce((sum, item) => {
        if (item.title && /Samples?\s-/i.test(item.title)) {
          return sum + Number(item.quantity || 0);
        }
        return sum;
      }, 0);

      const remainingAllowed = MAX_SAMPLE_QUANTITY - currentSampleQuantity;

      console.log(this.logPrefix, "Current sample quantity", currentSampleQuantity);
      
      if (/Samples?\s-/i.test(title)) {
        if (remainingAllowed <= 0) {
          console.log(this.logPrefix, "Cannot add any more sample items. Limit reached.");
      
          await this.removeItem(key, quantity, event);
      
          window.showSampleLimitWarning = true;
      
        } else if (quantity > remainingAllowed) {
          console.log(`Only ${remainingAllowed} sample items can be added. Adjusting quantity.`);
          quantity = remainingAllowed;
        } else {
          console.log(this.logPrefix,"Sample item can be added as requested.");
        }
      }
      console.log(this.logPrefix, "Final sample item quantity to add:", quantity);
    } else {
      return
    }

  }

  async removeItem(key, quantity, event) {

    console.log(this.logPrefix, "Removing item", key, quantity, event);
    let adjustedQuantity = quantity;

    if (event.type == "cart:added") {
      adjustedQuantity = quantity - 1;
    }
    
    const cartItems = { id: key, quantity: adjustedQuantity };
      await window.Stencil.Extensions.Cart.change(cartItems).finally(e => {
    });
  }

}

export default SampleProductValidation;